// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2dc98735511e0b1b617d","655":"c27b2d8b3a7eccf0306e"}[chunkId] + ".js";
};